import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class MassiveActionsGuard implements CanActivate {

    public canActivate() {
        let userProfile = JSON.parse(sessionStorage.getItem('user'));
        if (userProfile && userProfile.security && (userProfile.security.massiveTabVisible || userProfile.security.massDeviceTabVisible))
            return true;
        else return false;
    }

    // canActivateChild() {}

}
